
import { defineComponent } from 'vue'
import { useRoute } from 'vue-router'

import FlashMessage from '@/components/FlashMessage.vue'

export default defineComponent({
  name: 'app',
  components: {
    FlashMessage
  },
  computed: {
    layout() {
      return (useRoute().meta.layout) + '-layout'
    }
  },
})
